import React, {Component} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {updateModal} from '../../actions/modal.js';
import {Button, Modal, Grid,Row,Col,Clearfix} from 'react-bootstrap';
import Menu from '../menu/';
import Login from '../login/';
import Register from '../register/';

var loginButtons={
  borderRadius: '0%',
  marginTop:'25',
  width: '50%',
  color:'lightblue',
  letterSpacing:'2',
  fontSize:'1.2em',
  fontWeight:'100',
  background: 'transparent',
  border: '0px solid white',
  cursor:'pointer',
}
var divider={
  borderRadius: '0%',
  marginTop:'25',
  width: '50%%',
  color:'white',
  letterSpacing:'2',
  fontSize:'1.2em',
  fontWeight:'100',
  background: 'transparent',
  border: '0px solid white',
  cursor:'pointer',
}
var App = React.createClass({
  getInitialState: function() {

              return {
                  display:'login',
              }
      },
selectGameMenu(){
  var {dispatch} = this.props;
  dispatch(updateModal(true,<Menu/>));
},

showModal(content) {
  var {dispatch} = this.props;
  dispatch(updateModal(true,content));
},

renderModal(content) {
  var modalContent;
  if (content == 'login') {
    this.setState({ display: content})
    //modalContent = <Login/>;
  }
  if (content == 'register') {
    this.setState({ display: content})
      //modalContent = <Register/>;
  }
  if (content == 'menu') {
     modalContent =<Menu/>;
     this.showModal(modalContent)
  }
},

displayLogic(content) {
  if (content == 'login') {
    //modalContent = <Login/>;
    return (<Login/>)
  }
  if (content == 'register') {
      //modalContent = <Register/>;
      return (<Register/>)
  }
},
    render() {
      var {map, overlay,currentUser} = this.props;
      var buttonActive={
        borderRadius: '0%',
        marginTop:'25',
        color:'white',
        letterSpacing:'2',
        fontSize:'1.2em',
        fontWeight:'200',
        background: 'transparent',
        border: '0px solid white',
        cursor:'pointer',
        textDecoration: 'none',
      }
      var buttonNotActive={
        borderRadius: '0%',
        marginTop:'25',
        color:'gray',
        letterSpacing:'2',
        fontSize:'1.2em',
        fontWeight:'100',
        background: 'transparent',
        border: '0px solid white',
        cursor:'pointer',
        textDecoration: 'none',
      }
      var content = this.state.display;
      var loginStyle;
      var registerStyle;
      if (content == 'login')
      {
        loginStyle = buttonActive;
        registerStyle = buttonNotActive;
      }
      if (content == 'register')
      {
        loginStyle = buttonNotActive;
        registerStyle = buttonActive;
      }
      return (
        <div>
          <Link style={loginStyle} onClick={(event) => {this.renderModal('login');}}>Login </Link>
          <label style={divider}> | </label>
          <Link style={registerStyle}  onClick={(event) => {this.renderModal('register');}}> Register</Link><br/>
          {this.displayLogic(content)}
        </div>
      );
    }
  });

  module.exports = connect((state) => {
    return {currentUser: state.currentUser, map: state.map, overlay: state.overlay, modal: state.modal}
  })(App);



// WEBPACK FOOTER //
// ./src/app/components/login_register/index.jsx